<div
    class="flex flex-col pt-[var(--ion-safe-area-top)]"
    #bannersContainer
    *ngIf="env.SHOW_BANNERS && (banners$ | async)?.length">
    <rwidget-banner *ngFor="let banner of banners$ | async" [bannerMessage]="banner"></rwidget-banner>
</div>
<section
    class="z-40 flex grow flex-col md:grid md:grid-cols-[25rem_1fr] md:overflow-hidden"
    [style.background-color]="'var(--color-content-background)'">
    <div class="overflow-y-auto rounded-t-2xl bg-[#F0F0F0] dark:bg-contrast-black md:max-h-[90dvh]">
        <rwidget-small-screen-sheet-modal-container
            #panel
            *ngIf="initialBreakpointIndex !== null || !deviceStatus"
            [fullscreen]="!deviceStatus"
            [initialBreakpointIndex]="env.EXPLORE?.BREAKPOINT_INDEX ?? initialBreakpointIndex"
            [isFullHeightContainer]="env.IS_MOBILE_APP"
            [minimalBreakpointOffset]="modalBreakpointOffset"
            [isShowAdditionalBreakpoint]="true"
            (fullscreenChange)="onFullscreenChanged($event)"
            (didPresent)="didPresentModal = true">
            <router-outlet></router-outlet>
        </rwidget-small-screen-sheet-modal-container>
    </div>
    <rwidget-map
        class="flex h-full w-full grow touch-none flex-col"
        *ngIf="deviceStatus && (!isNativeApp || didPresentModal)"
        [attr.aria-label]="'MAP_HAS_REAL_TIME_BUS_WRITE_TO_SEARCH' | translate"
        [class.space-safe-zone]="env.IS_MOBILE_APP && !(banners$ | async)?.length"
        [latitude]="mapCenter.latitude"
        [longitude]="mapCenter.longitude"
        [allowPointClick]="env.EXPLORE?.SHOW_FAVORITE_LOCATIONS"
        [hasViewSettingsControl]="true"
        (mapReady)="onMapReady()"
        (pointClicked)="clickedLocation($event)"
        (zoomChanged)="onZoomChanged($event)"
        role="region"
        ridangoHideFromScreenreader>
        <rwidget-map-popup *ngIf="this.env.EXPLORE?.SELECTED_BUS_STOPPED" [coordinates]="clickedBusLocation">
            <div
                class="rounded-lg bg-white p-4 dark:bg-contrast-black dark:text-contrast-yellow"
                *ngIf="!clickedBusData">
                <ridango-ui-basic-loading-spinner> </ridango-ui-basic-loading-spinner>
            </div>
            <div
                class="flex cursor-pointer items-center gap-2 rounded-lg bg-white p-4 dark:bg-contrast-black dark:text-contrast-yellow"
                *ngIf="clickedBusData"
                (click)="clickOnRouteInfo($event)">
                <ion-icon
                    class="var-app-light:text-grey-zambezy orb-app-light:text-grey-zambezy h-[1.375rem] w-[1.375rem] text-white dark:text-contrast-yellow"
                    [src]="(assetsPath$ | async) + '/img/explore/mode_bus.svg'"
                    aria-hidden="true"></ion-icon>
                <p class="!m-0 flex-1 text-base">{{ clickedBusData?.name }}</p>
                <mat-icon *ngIf="clickedBusData?.tripId">keyboard_arrow_right</mat-icon>
            </div>
        </rwidget-map-popup>
        <rwidget-map-layer-group
            *ngIf="(allFormattedStops$ | async) || (selectedStop?.length && !isSelectedStopFavorite())"
            [label]="'SCHEDULE_STOPS_LAYER' | translate"
            name="schedule-stops">
            <!-- All stops -->
            <ng-container *ngIf="allFormattedStops$ | async as allStops">
                <ng-container *ngIf="assetsPath$ | async as assetsPath">
                    <rwidget-map-marker-group
                        *ngIf="IconSizeOrderEnum[zoomIconSizeValue] >= IconSizeOrderEnum[stopsVisibleFromZoomSize]"
                        [markers]="allStops"
                        [iconZoomSize]="zoomIconSizeValue"
                        [shouldDecreaseMarkersZIndex]="!isSelectedStopFavorite()"
                        [deleteOld]="true"
                        (markerClicked)="onStopClick($event)">
                        <rwidget-map-icon
                            [preserveFill]="true"
                            [iconClass]="'text-secondary'"
                            [url]="
                                zoomIconSizeValue === IconSizeEnum.small
                                    ? assetsPath + '/leaflet/small_stop_icon.svg'
                                    : iconStop
                            "
                            [size]="[mapIcons?.[MarkerType.stop]?.size, null]"
                            [anchor]="[mapIcons?.[MarkerType.stop]?.anchor[0], mapIcons?.[MarkerType.stop]?.anchor[1]]"
                            [popupAnchor]="[0, -10]"
                            [forceContentClone]="true">
                        </rwidget-map-icon>

                        <rwidget-map-popup *ngIf="zoomIconSizeValue !== IconSizeEnum.small">
                            <ng-container *ngTemplateOutlet="stopPopupTemplate"></ng-container>
                        </rwidget-map-popup>
                    </rwidget-map-marker-group>
                </ng-container>
            </ng-container>

            <!-- Selected stop -->
            <ng-container *ngIf="!isSelectedStopFavorite() && selectedStop?.length">
                <ng-container *ngIf="assetsPath$ | async as assetsPath">
                    <rwidget-map-marker-group
                        [markers]="selectedStop"
                        [iconZoomSize]="zoomIconSizeValue"
                        [deleteOld]="true"
                        (markerClicked)="onStopClick($event)">
                        <rwidget-map-icon
                            [preserveFill]="true"
                            [iconClass]="'text-secondary'"
                            [url]="
                                zoomIconSizeValue === IconSizeEnum.small
                                    ? assetsPath + '/leaflet/small_stop_icon.svg'
                                    : iconStopHighlighted
                            "
                            [size]="[mapIcons?.[MarkerType.stopSelected]?.size, null]"
                            [anchor]="[
                                mapIcons?.[MarkerType.stopSelected]?.anchor[0],
                                mapIcons?.[MarkerType.stopSelected]?.anchor[1]
                            ]"
                            [popupAnchor]="[0, -10]"
                            [forceContentClone]="true">
                        </rwidget-map-icon>

                        <rwidget-map-polyline
                            *ngIf="exploreMapRoute$ | async as route"
                            [weight]="zoomIconSizeValue === IconSizeEnum.large ? 6 : 4"
                            [encodedPath]="route.polyline"
                            [color]="route.polylineColor">
                        </rwidget-map-polyline>

                        <rwidget-map-popup *ngIf="zoomIconSizeValue !== IconSizeEnum.small">
                            <ng-container *ngTemplateOutlet="stopPopupTemplate"></ng-container>
                        </rwidget-map-popup>
                    </rwidget-map-marker-group>
                </ng-container>
            </ng-container>
        </rwidget-map-layer-group>

        <ng-template #stopPopupTemplate>
            <div
                class="flex cursor-pointer items-center gap-2 rounded-lg bg-white p-3 dark:bg-contrast-black dark:text-contrast-yellow"
                (click)="clickOnStopInfo(clickedStop)"
                role="button"
                tabindex="0">
                <ion-icon
                    class="vl-app-light:!h-8 vl-app-light:!w-8 vl-app-light:text-black var-app-light:text-grey-zambezy orb-app-light:text-secondary hu-light:text-secondary h-[1.375rem] w-[1.375rem] rounded text-white dark:text-contrast-yellow"
                    [src]="
                        (assetsPath$ | async) +
                        (env.EXPLORE?.USE_CONTRAST_ICON && (isContrast$ | async)
                            ? '/img/explore/bus-contrast.svg'
                            : '/img/explore/bus.svg')
                    "
                    [attr.aria-label]="'STOP' | translate"
                    name="bus-outline"
                    aria-hidden="true"></ion-icon>
                <p class="!m-0 flex-1 text-base">
                    {{ clickedStop?.name }}
                    <span *ngIf="clickedStop?.desc && env.EXPLORE?.SHOW_MUNICIPALITY_IN_STOP_NAME"
                        >({{ clickedStop.desc }})</span
                    >
                </p>
                <span class="vl-app-light:hidden flex items-center">
                    <mat-icon aria-hidden="true">keyboard_arrow_right</mat-icon>
                </span>
                <!-- <img> is needed so that iOS VoiceOver could capture correct box size correctly for popup -->
                <img
                    class="vl-app-light:block hidden h-8 w-8 text-grey-zambezy dark:text-contrast-yellow"
                    [src]="(assetsPath$ | async) + '/img/explore/caret-forward.svg'"
                    [attr.aria-label]="'STOP' | translate"
                    aria-hidden="true" />
            </div>
        </ng-template>

        <rwidget-map-layer-group
            *ngIf="exploreMapRoute$ | async"
            [label]="'EXPLORE_TRIP_LAYER_NAME' | translate"
            [fit]="fitMap$ | async">
            <rwidget-map-polyline
                *ngIf="exploreMapRoute$ | async"
                [weight]="zoomIconSizeValue === IconSizeEnum.large ? 6 : 4"
                [encodedPath]="(exploreMapRoute$ | async)?.polyline"
                [color]="(exploreMapRoute$ | async)?.polylineColor"></rwidget-map-polyline>
            <rwidget-map-marker-group
                *ngIf="zoomIconSizeValue !== IconSizeEnum.small && !selectedStop?.length"
                [markers]="(exploreMapRoute$ | async)?.stops"
                [iconZoomSize]="zoomIconSizeValue"
                (markerClicked)="onRouteStopClick($event)"
                deleteOld="true">
                <rwidget-map-icon
                    [size]="[mapIcons?.[MarkerType.stopNode]?.size, mapIcons?.[MarkerType.stopNode]?.size]"
                    [anchor]="[mapIcons?.[MarkerType.stopNode]?.anchor[0], mapIcons?.[MarkerType.stopNode]?.anchor[1]]"
                    [popupAnchor]="[0, -10]"
                    [forceContentClone]="true">
                    <div
                        class="h-full w-full rounded-full border-[3px] border-solid bg-white"
                        [style.border-color]="
                            (isContrast$ | async) ? 'black' : (exploreMapRoute$ | async)?.polylineColor
                        "
                        [style.background-color]="
                            env.APP_NAME === 'vastmanland-app' ? (exploreMapRoute$ | async)?.polylineColor : 'white'
                        "></div>
                </rwidget-map-icon>
                <rwidget-map-popup *ngIf="zoomIconSizeValue !== IconSizeEnum.small">
                    <div class="popup-title text-base">
                        <p>{{ routeClickedStop?.name }}</p>
                        <p *ngIf="routeClickedStop?.code">{{ routeClickedStop?.code }}</p>
                        <p *ngIf="routeClickedStop?.departureClockTime">
                            {{ 'DEPARTURE' | translate }}: {{ routeClickedStop?.departureClockTime }}
                        </p>
                        <p *ngIf="routeClickedStop?.arrivalClockTime">
                            {{ 'ARRIVAL' | translate }}: {{ routeClickedStop?.arrivalClockTime }}
                        </p>
                    </div>
                </rwidget-map-popup>
            </rwidget-map-marker-group>

            <rwidget-map-marker-group
                *ngIf="userDepartureBusStop"
                [markers]="[userDepartureBusStop]"
                [iconZoomSize]="zoomIconSizeValue"
                (markerClicked)="onRouteStopClick($event)"
                deleteOld="true">
                <rwidget-map-icon
                    [url]="circleHuman"
                    [size]="
                        env.EXPLORE?.MAP_SELECTED_STOP_ICON_SIZE
                            ? [env.EXPLORE?.MAP_SELECTED_STOP_ICON_SIZE, env.EXPLORE?.MAP_SELECTED_STOP_ICON_SIZE]
                            : null
                    "
                    [anchor]="
                        env.EXPLORE?.MAP_SELECTED_STOP_ICON_SIZE
                            ? [
                                  env.EXPLORE?.MAP_SELECTED_STOP_ICON_SIZE / 2,
                                  env.EXPLORE?.MAP_SELECTED_STOP_ICON_SIZE / 2
                              ]
                            : [9, 24]
                    "></rwidget-map-icon>
                <rwidget-map-popup *ngIf="zoomIconSizeValue !== IconSizeEnum.small">
                    <div class="popup-title text-base">
                        <p>{{ userDepartureBusStop?.name }}</p>
                        <p *ngIf="userDepartureBusStop?.code">
                            {{ userDepartureBusStop?.code }}
                        </p>
                        <p *ngIf="userDepartureBusStop?.departureClockTime">
                            {{ 'DEPARTURE' | translate }}:
                            {{ userDepartureBusStop?.departureClockTime }}
                        </p>
                        <p *ngIf="routeClickedStop?.arrivalClockTime">
                            {{ 'ARRIVAL' | translate }}:
                            {{ userDepartureBusStop?.arrivalClockTime }}
                        </p>
                    </div>
                </rwidget-map-popup>
            </rwidget-map-marker-group>
        </rwidget-map-layer-group>

        <rwidget-map-layer-group
            *ngIf="env.EXPLORE?.ALWAYS_SHOW_BUSES_TOGGLE || zoomIconSizeValue !== IconSizeEnum.small"
            [label]="'SCHEDULE_BUSES_LAYER' | translate"
            name="schedule-buses">
            <rwidget-map-marker
                *ngFor="let bus of showedBusLocations$ | async"
                [latitude]="bus.latitude"
                [longitude]="bus.longitude">
                <rwidget-map-icon
                    [size]="[mapIcons?.[MarkerType.bus]?.size, mapIcons?.[MarkerType.bus]?.size]"
                    [anchor]="[mapIcons?.[MarkerType.bus]?.anchor[0], mapIcons?.[MarkerType.bus]?.anchor[1]]"
                    [popupAnchor]="[0, -10]">
                    <rwidget-map-bus-icon
                        [isBusSelected]="isBusSelected(bus)"
                        [bus]="bus"
                        [generalBusIcon]="tripWithBusSelected && env.JOURNEY_PLANNER?.GENERAL_SELECTED_BUS_TRIP_ICON"
                        [zoomSize]="zoomIconSizeValue"
                        (busClicked)="onBusClick($event)"></rwidget-map-bus-icon>
                </rwidget-map-icon>
                <rwidget-map-popup *ngIf="!this.env.EXPLORE?.SELECTED_BUS_STOPPED">
                    <div
                        class="rounded-lg bg-white p-4 dark:bg-contrast-black dark:text-contrast-yellow"
                        *ngIf="!clickedBusData">
                        <ridango-ui-basic-loading-spinner> </ridango-ui-basic-loading-spinner>
                    </div>
                    <div
                        class="flex cursor-pointer items-center gap-2 rounded-lg bg-white p-4 dark:bg-contrast-black dark:text-contrast-yellow"
                        *ngIf="clickedBusData"
                        (click)="clickOnRouteInfo($event)">
                        <ion-icon
                            class="h-[1.375rem] w-[1.375rem] text-white dark:text-contrast-yellow"
                            [src]="(assetsPath$ | async) + '/img/explore/mode_bus.svg'"
                            aria-hidden="true"></ion-icon>
                        <p class="!m-0 flex-1 text-base">{{ clickedBusData?.name }}</p>
                        <mat-icon *ngIf="clickedBusData?.tripId">keyboard_arrow_right</mat-icon>
                    </div>
                </rwidget-map-popup>
            </rwidget-map-marker>
            <rwidget-map-marker
                *ngIf="this.env.EXPLORE?.SELECTED_BUS_STOPPED && clickedBusData"
                [latitude]="clickedBus.latitude"
                [longitude]="clickedBus.longitude">
                <rwidget-map-icon
                    [iconClass]="'text-secondary'"
                    [size]="[mapIcons?.[MarkerType.bus]?.size, mapIcons?.[MarkerType.bus]?.size]"
                    [anchor]="[mapIcons?.[MarkerType.bus]?.anchor[0], mapIcons?.[MarkerType.bus]?.anchor[1]]"
                    [popupAnchor]="[0, -10]">
                    <rwidget-map-bus-icon
                        [zoomSize]="zoomIconSizeValue"
                        [isBusSelected]="isBusSelected(clickedBus)"
                        [generalBusIcon]="tripWithBusSelected && env.JOURNEY_PLANNER?.GENERAL_SELECTED_BUS_TRIP_ICON"
                        [bus]="clickedBus"
                        (busClicked)="onBusClick($event)"></rwidget-map-bus-icon>
                </rwidget-map-icon>
            </rwidget-map-marker>
        </rwidget-map-layer-group>

        <rwidget-map-locator></rwidget-map-locator>

        <!--all favorite objects should be on one layer-->
        <rwidget-map-layer-group
            *ngIf="env.EXPLORE?.SHOW_FAVORITE_LOCATIONS"
            [label]="'SAVED_LOCATIONS_LAYER' | translate"
            name="favorite-locations">
            <ng-container *ngIf="assetsPath$ | async as assetsPath">
                <!-- Favorite locations -->
                <rwidget-map-marker-group
                    *ngIf="!env.EXPLORE?.HIDE_FAVORITE_FROM_MAP"
                    [markers]="favoriteLocations"
                    [iconZoomSize]="zoomIconSizeValue"
                    [deleteOld]="true"
                    (markerClicked)="clickedFavoriteLocation($event)">
                    <rwidget-map-icon
                        [preserveFill]="true"
                        [url]="assetsPath + '/leaflet/saved-location.svg'"
                        [size]="[mapIcons?.[MarkerType.location]?.size, mapIcons?.[MarkerType.location]?.size]"
                        [anchor]="[
                            mapIcons?.[MarkerType.location]?.anchor[0],
                            mapIcons?.[MarkerType.location]?.anchor[1]
                        ]"
                        [popupAnchor]="[0, -10]"
                        [forceContentClone]="true">
                    </rwidget-map-icon>
                </rwidget-map-marker-group>

                <!-- Favorite stops -->
                <rwidget-map-marker-group
                    *ngIf="!env.EXPLORE?.HIDE_FAVORITE_FROM_MAP"
                    [markers]="favoriteStops$ | async"
                    [iconZoomSize]="zoomIconSizeValue"
                    [deleteOld]="true"
                    (markerClicked)="onStopClick($event)">
                    <rwidget-map-icon
                        [preserveFill]="true"
                        [url]="
                            zoomIconSizeValue === IconSizeEnum.small
                                ? assetsPath + '/leaflet/small_stop_icon.svg'
                                : iconFavoriteStop
                        "
                        [iconClass]="'text-secondary'"
                        [size]="[mapIcons?.[MarkerType.stopFavorite]?.size, null]"
                        [anchor]="[
                            mapIcons?.[MarkerType.stopFavorite]?.anchor[0],
                            mapIcons?.[MarkerType.stopFavorite]?.anchor[1]
                        ]"
                        [popupAnchor]="[0, -10]"
                        [forceContentClone]="true">
                    </rwidget-map-icon>
                    <rwidget-map-popup *ngIf="zoomIconSizeValue !== IconSizeEnum.small">
                        <ng-container *ngTemplateOutlet="stopPopupTemplate"></ng-container>
                    </rwidget-map-popup>
                </rwidget-map-marker-group>

                <!-- Selected favorite stop -->
                <rwidget-map-marker-group
                    *ngIf="isSelectedStopFavorite() && !env.EXPLORE?.HIDE_FAVORITE_FROM_MAP"
                    [markers]="selectedStop"
                    [iconZoomSize]="zoomIconSizeValue"
                    [deleteOld]="true"
                    (markerClicked)="onStopClick($event)">
                    <rwidget-map-icon
                        [preserveFill]="true"
                        [url]="
                            zoomIconSizeValue === IconSizeEnum.small
                                ? assetsPath + '/leaflet/small_stop_icon.svg'
                                : iconFavoriteStop
                        "
                        [iconClass]="'text-secondary'"
                        [size]="[mapIcons?.[MarkerType.stopSelected]?.size, null]"
                        [anchor]="[
                            mapIcons?.[MarkerType.stopSelected]?.anchor[0],
                            mapIcons?.[MarkerType.stopSelected]?.anchor[1]
                        ]"
                        [popupAnchor]="[0, -10]"
                        [forceContentClone]="true">
                    </rwidget-map-icon>
                    <rwidget-map-popup *ngIf="zoomIconSizeValue !== IconSizeEnum.small">
                        <ng-container *ngTemplateOutlet="stopPopupTemplate"></ng-container>
                    </rwidget-map-popup>
                </rwidget-map-marker-group>

                <!-- Selected favorite locations -->
                <rwidget-map-marker-group
                    [markers]="selectedFavoriteLocations"
                    [iconZoomSize]="zoomIconSizeValue"
                    [deleteOld]="true"
                    (markerClicked)="clickedFavoriteLocation($event)">
                    <rwidget-map-icon
                        [preserveFill]="true"
                        [url]="
                            assetsPath +
                            (env.EXPLORE?.HIDE_FAVORITE_FROM_MAP
                                ? '/img/explore/location.svg'
                                : '/leaflet/saved-location.svg')
                        "
                        [size]="[
                            mapIcons?.[MarkerType.selectedLocation]?.size,
                            mapIcons?.[MarkerType.selectedLocation]?.size
                        ]"
                        [anchor]="[
                            mapIcons?.[MarkerType.selectedLocation]?.anchor[0],
                            mapIcons?.[MarkerType.selectedLocation]?.anchor[1]
                        ]"
                        [popupAnchor]="[0, -10]"
                        [forceContentClone]="true">
                    </rwidget-map-icon>
                </rwidget-map-marker-group>
            </ng-container>
        </rwidget-map-layer-group>

        <rwidget-map-layer-group *ngIf="env.EXPLORE?.SHOW_FAVORITE_LOCATIONS">
            <rwidget-map-marker
                *ngIf="showSelectedLocation()"
                [latitude]="selectedLocation?.latitude"
                [longitude]="selectedLocation?.longitude">
                <rwidget-map-icon
                    [preserveFill]="true"
                    [anchor]="[17, 17]"
                    [size]="[34, 34]"
                    [url]="(assetsPath$ | async) + '/img/explore/location.svg'">
                </rwidget-map-icon>
            </rwidget-map-marker>
        </rwidget-map-layer-group>
    </rwidget-map>
</section>
